import { makeFetchSlice, fetchEdgeDataThunk } from 'app/redux-fetch'
import { AppDispatch } from 'app/store'

import {
  fetchHome,
  inviteHomeUser,
  InviteUserBody,
  requestAccess,
  RequestAccessBody,
  getPartners,
  getPartnersInbound,
} from './api'
import type { Home } from './types'
import {
  SELECTED_HOME_REDUCER_NAME,
  INVITE_HOME_USER_REDUCER_NAME,
  REQUEST_ACCESS_REDUCER_NAME,
} from './consts'

const selectedHomeSlice = makeFetchSlice<Home>(SELECTED_HOME_REDUCER_NAME)
export const selectedHomeReducer = selectedHomeSlice.reducer
export const selectedHomeActions = selectedHomeSlice.actions

export const fetchHomeThunk = (homeId: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchEdgeDataThunk({
        dispatch,
        actions: selectedHomeActions,
        asyncFunc: () => fetchHome(homeId),
      })
    } catch (error) {
      console.log('Error fetching home', error)
    }
  }
}

const inviteHomeUserSlice = makeFetchSlice(INVITE_HOME_USER_REDUCER_NAME)

export const inviteHomeUserReducer = inviteHomeUserSlice.reducer
export const inviteHomeUserActions = inviteHomeUserSlice.actions

export const inviteHomeUserThunk = (homeId: string, body: InviteUserBody) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchEdgeDataThunk({
        dispatch,
        actions: inviteHomeUserActions,
        asyncFunc: () => inviteHomeUser(homeId, body),
      })

      await dispatch(fetchHomeThunk(homeId))
    } catch (error) {
      console.log('Error inviting home user', error)
    }
  }
}

const requestAccessSlice = makeFetchSlice(REQUEST_ACCESS_REDUCER_NAME)

export const requestAccessReducer = requestAccessSlice.reducer
export const requestAccessActions = requestAccessSlice.actions

export const requestAccessThunk = (
  domainId: string,
  homeId: string,
  body?: RequestAccessBody
) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchEdgeDataThunk({
        dispatch,
        actions: requestAccessActions,
        asyncFunc: () => requestAccess(domainId, homeId, body),
      })
    } catch (error) {
      console.log('Error requesting home access', error)
    }
  }
}

const partnersSlice = makeFetchSlice('partners')

export const partnersReducer = partnersSlice.reducer
export const partnersActions = partnersSlice.actions

export const getPartnersThunk = (homeId: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchEdgeDataThunk({
        dispatch,
        actions: partnersActions,
        asyncFunc: () => getPartners(homeId),
      })
    } catch (error) {
      console.log('Error fetching partners for home', homeId, error)
    }
  }
}

const partnersInboundSlice = makeFetchSlice('partnersInbound')

export const partnersInboundReducer = partnersInboundSlice.reducer
export const partnersInboundActions = partnersInboundSlice.actions

export const getPartnersInboundThunk = (homeId: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchEdgeDataThunk({
        dispatch,
        actions: partnersInboundActions,
        asyncFunc: () => getPartnersInbound(homeId),
      })
    } catch (error) {
      console.log('Error fetching partnersInbound for home', homeId, error)
    }
  }
}
